import React, { Component } from "react";
import { Link } from "react-router-dom";

// Layout
import Header from "../layout/header/header1";

// Images
import bannerImg from "../../images/banner/banner3.jpg";
import news16_1 from "../../images/news/news16_1.png";
import news16_2 from "../../images/news/news16_2.png";
import news16_3 from "../../images/news/news16_3.png";
import news16_4 from "../../images/news/news16_4.png";
import news16_5 from "../../images/news/news16_5.png";
import news16_6 from "../../images/news/news16_6.png";

import { withTranslation } from "react-i18next";
import ReactMarkdown from "react-markdown";

class news16 extends Component {
    componentDidMount() {}

    componentWillMount() {
        const { t } = this.props;
        document.getElementById("title").innerText = t("News16_Title");
    }

    componentWillUnmount() {
        const { t } = this.props;
        document.getElementById("title").innerText = t("Home_Title");
    }

    render() {
        const { t } = this.props;

        return (
            <>
                <Header />

                <div className="page-content">
                    <div
                        className="page-banner ovbl-dark"
                        style={{ backgroundImage: "url(" + bannerImg + ")" }}
                    >
                        <div className="container">
                            <div className="page-banner-entry">
                                <h1 className="text-white">{t("News16_Title")}</h1>
                            </div>
                        </div>
                    </div>

                    <div className="breadcrumb-row">
                        <div className="container">
                            <ul className="list-inline">
                                <li>
                                    <Link to="/">{t("News16_LinkHome")}</Link>
                                </li>
                                <li>{t("News16_LinkCourses")}</li>
                            </ul>
                        </div>
                    </div>

                    <div className="content-block">
                        <div className="section-area section-sp1">
                            <div className="container">
                                <div className="row d-flex flex-row-reverse">
                                    <div className="col-xl-9 col-lg-8 col-md-12 col-sm-12">
                                        <div className="courses-post">

                                            <h1>{t("News16_Content_H")}</h1>

                                            {/* P1 */}
                                            <ReactMarkdown>{t("News16_P1_MD")}</ReactMarkdown>

                                            {/* IMG 1 */}
                                            <div style={{ textAlign: "center", margin: "20px 0" }}>
                                                <img
                                                    src={news16_1}
                                                    alt={t("News16_IMG1_DESC")}
                                                />
                                                <div style={{ marginTop: "10px", fontStyle: "italic", color: "#555" }}>
                                                    {t("News16_IMG1_DESC")}
                                                </div>
                                            </div>

                                            {/* P2 */}
                                            <ReactMarkdown>{t("News16_P2_MD")}</ReactMarkdown>

                                            {/* IMG 2 */}
                                            <div style={{ textAlign: "center", margin: "20px 0" }}>
                                                <img
                                                    src={news16_2}
                                                    alt={t("News16_IMG2_DESC")}
                                                />
                                                <div style={{ marginTop: "10px", fontStyle: "italic", color: "#555" }}>
                                                    {t("News16_IMG2_DESC")}
                                                </div>
                                            </div>

                                            {/* P3 */}
                                            <ReactMarkdown>{t("News16_P3_MD")}</ReactMarkdown>

                                            {/* IMG 3 */}
                                            <div style={{ textAlign: "center", margin: "20px 0" }}>
                                                <img
                                                    src={news16_3}
                                                    alt={t("News16_IMG3_DESC")}
                                                />
                                                <div style={{ marginTop: "10px", fontStyle: "italic", color: "#555" }}>
                                                    {t("News16_IMG3_DESC")}
                                                </div>
                                            </div>

                                            {/* P4 */}
                                            <ReactMarkdown>{t("News16_P4_MD")}</ReactMarkdown>

                                            {/* IMG 4 */}
                                            <div style={{ textAlign: "center", margin: "20px 0" }}>
                                                <img
                                                    src={news16_4}
                                                    alt={t("News16_IMG4_DESC")}
                                                />
                                                <div style={{ marginTop: "10px", fontStyle: "italic", color: "#555" }}>
                                                    {t("News16_IMG4_DESC")}
                                                </div>
                                            </div>

                                            {/* P5 */}
                                            <ReactMarkdown>{t("News16_P5_MD")}</ReactMarkdown>

                                            {/* IMG 5 */}
                                            <div style={{ textAlign: "center", margin: "20px 0" }}>
                                                <img
                                                    src={news16_5}
                                                    alt={t("News16_IMG5_DESC")}
                                                />
                                                <div style={{ marginTop: "10px", fontStyle: "italic", color: "#555" }}>
                                                    {t("News16_IMG5_DESC")}
                                                </div>
                                            </div>

                                            {/* P6 */}
                                            <ReactMarkdown>{t("News16_P6_MD")}</ReactMarkdown>

                                            {/* IMG 6 */}
                                            <div style={{ textAlign: "center", margin: "20px 0" }}>
                                                <img
                                                    src={news16_6}
                                                    alt={t("News16_IMG6_DESC")}
                                                />
                                                <div style={{ marginTop: "10px", fontStyle: "italic", color: "#555" }}>
                                                    {t("News16_IMG6_DESC")}
                                                </div>
                                            </div>

                                            {/* P7 */}
                                            <ReactMarkdown>{t("News16_P7_MD")}</ReactMarkdown>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </>
        );
    }
}

export default news16 = withTranslation()(news16);
